

















import Vue from 'vue';
import {
  Component, Inject, Provide, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import {
  KCardHeader, KCardHeaderBtn,
} from '@kasasa/fbase-components';
import {
  Alert, NoticeClass, AuthStore,
} from '@kasasa/fbase-components/lib';
import AuditMessagesTable from '@/components/auditmessages/AuditMessagesTable.vue';


@Component({
  computed: mapState([
    'fiId',
  ]),
  components: {
    KCardHeader,
    KCardHeaderBtn,
    AuditMessagesTable,
  },
})
export default class AuditMessages extends Vue {
  headerItems: any = [{
    text: 'Rewards Processing',
    disabled: false,
    link: false,
  },
  {
    text: 'Audit Messages',
    disabled: true,
  }];
}
